import { IAppStoreInterface } from 'types/AppstoreInterface'
import { create } from 'zustand'

export const useAppStore = create<IAppStoreInterface>((set, get) => ({
  activeWorkspace: null,
  setActiveWorkspace: (newActiveWorkspace) => set({ activeWorkspace: newActiveWorkspace }),
}))
